// Centralne źródło prawdy dla liczby kroków (pageCount) per typ pomiaru.
// Backend zwraca to w /measurement/current-info. W trybie offline musimy to odtworzyć.

export const MEASUREMENT_PAGE_COUNT_BY_TYPE: Record<string, number> = {
  windowsInRawCondition: 4,
  windowsReplacement: 4,
  externalDoorsInRawCondition: 4,
  externalDoorsReplacement: 4,
  garageDoor: 3,
  rollerBlindsAndBlinds: 3,
  windowSills: 3,
  interiorDoors: 3,
  floors: 4,
  skirtingBoards: 3,
};

export function getMeasurementPageCount(type: string | null | undefined): number {
  if (!type) return 1;
  return MEASUREMENT_PAGE_COUNT_BY_TYPE[type] ?? 1;
}
